import type { ReactNode, CSSProperties } from 'react'
import { EasyImg } from 'src/components'
import { appStore } from 'src/stores'
import { getImgBase } from 'src/utils/axios'
import { get } from 'lodash'
import { pictureThumb } from 'src/assets/base64'
import 'src/styles/components/base/pictureThumb.less'

type Props = {
  picFilter: any[],
  targetData?: any,
  defaultThumb: string,
  children?: ReactNode,
  thumbClassName?: string,
  thumbStyle?: CSSProperties,
  className?: string,
  style?: CSSProperties
}

const PictureThumb = (props: Props) => {
  /**
   * thumbCodes: ['A001']
   * thumbConfigs: [{ target: 'A001', rules: [{ field: 'Level1', operate: 1, value: 1 }] }]
   * 对 thumbConfigs 进行顺序遍历，rules 里面的规则是 and 规则，所有 rules 符合条件，则取 target 作为图片，
   * 有一个特殊逻辑，如果遍历到 rules 为空数组，则视为默认符合条件，可直接取 target 作为图片
   */
  const { picFilter } = props

  const thumbCodes: string[] = []
  const thumbConfigs: any[] = []
  if (Array.isArray(picFilter) && picFilter.length) {
    picFilter.forEach(({ ID, Nav_PicFilterDetail = [] }) => {
      thumbCodes.push(ID)
      thumbConfigs.push({
        target: ID,
        rules: Nav_PicFilterDetail.map((item: any) => ({
          field: item.FIELD_TYPE === 1 ? `Node.${item.NAME}` : item.NAME,
          operate: Number(item.OPERATE),
          value: String(item.VALUE)
        }))
      })
    })
  }

  // 获取全局图片配置
  const globalThumbConfig = thumbConfigs.filter(config => !config.rules?.length)
  // 获取节点对应图片资源
  let thumbTarget = globalThumbConfig[0]?.target
  thumbConfigs.forEach((item: any) => {
    const { target, rules = [] } = item
    let matchRules = true
    rules.forEach((rule: any) => {
      const { field, operate, value } = rule
      const fieldValue = String(get(props.targetData, field))
      switch (operate) {
        case 1:
          matchRules = fieldValue === value
          break
        default:
          matchRules = fieldValue === value
          break
      }
    })
    matchRules && (thumbTarget = target)
  })

  let picture = props.defaultThumb
  const find = picFilter.find(pic => pic.ID === thumbTarget)?.PIC_URL
  if (find) {
    let files = []
    try { files = JSON.parse(find) } catch (err) { }
    files[0]?.FilePath && (picture = `${appStore.current.baseConfig.FileDomain || getImgBase()}${files[0].FilePath}`)
  }

  return (
    <div className={`picture-thumb ${props.className}`} style={props.style}>
      <EasyImg
        src={picture}
        defaultSrc={props.defaultThumb}
        className={`picture-thumb__img ${props.thumbClassName}`}
        style={props.thumbStyle}
      />
      {props.children}
    </div>
  )
}

PictureThumb.defaultProps = {
  defaultThumb: pictureThumb
}

export default PictureThumb